import { ArrowDownUp, FilterIcon, Inbox } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import { useDataTableOptions } from "../hooks/useDataTableOptions";

export default function EmptyState() {
  const { t } = useTranslation();
  const options = useDataTableOptions();

  return (
    <div
      data-testid="empty-state"
      className="h-40 flex flex-col justify-center items-center gap-4 whitespace-normal text-center px-5 bg-slate-200"
    >
      <p className="text-lg flex items-center gap-2">
        <Inbox /> {t("table.noData")}
      </p>
      {options.isFilteredOrSorted() && (
        <>
          <p>{t("table.noDataFilteredOrSorted")}</p>
          <p className="flex gap-4">
            <Button
              variant="outline"
              disabled={!options.isFiltered()}
              onClick={options.resetFilters}
            >
              <FilterIcon /> {t("table.clearFilters")}
            </Button>
            <Button
              variant="outline"
              disabled={!options.isSorted()}
              onClick={options.resetSorting}
            >
              <ArrowDownUp /> {t("table.clearSorting")}
            </Button>
          </p>
        </>
      )}
    </div>
  );
}
